.body {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
  margin: 0 auto;
  max-width: 1200px;
  padding: var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-16);
  width: 100%;
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
  list-style: none;
  margin: 0;
  padding: 0;
}

@media (max-width: 599.98px) {
  .body {
    padding: var(--pgm-sys-spacing-4) var(--pgm-sys-spacing-4) var(--pgm-sys-spacing-12);
  }
}
